import * as React from 'react'

import type { DefaultParams, UsePayrollResultFilterReturn } from './usePayrollResultFilter'
import usePayrollResultFilters from './usePayrollResultFilter'

const PayrollResultFilterContext = React.createContext<UsePayrollResultFilterReturn | null>(null)

interface PayrollResultFilterProviderProps {
  defaultValues: DefaultParams
}

export const PayrollResultFilterProvider = ({
  defaultValues,
  children,
}: React.PropsWithChildren<PayrollResultFilterProviderProps>) => {
  const filter = usePayrollResultFilters(defaultValues)
  return (
    <PayrollResultFilterContext.Provider value={filter}>
      {children}
    </PayrollResultFilterContext.Provider>
  )
}

export const usePayrollResultFilterContext = (): UsePayrollResultFilterReturn => {
  const filter = React.useContext(PayrollResultFilterContext)

  if (!filter) {
    throw new Error(
      'usePayrollResultFilterContext must be used within a PayrollResultFilterProvider'
    )
  }

  return filter
}
